import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Menu } from "lucide-react";
import Sidebar from "@/components/Sidebar";
import { Toaster } from "@/components/ui/sonner";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { BrandingProvider } from "@/context/BrandingContext";
import { BrandHeader } from "@/components/BrandHeader";
import { MailJobsIndicator } from "@/components/MailJobsIndicator";

export default function Layout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const timer = useRef(null);
  const location = useLocation();
  const [navOpen, setNavOpen] = useState(false);
  useEffect(() => { setNavOpen(false); }, [location.pathname]);

  useEffect(() => {
    let minutes = 30;
    const reset = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(async () => {
        await logout();
        navigate("/login");
      }, minutes * 60000);
    };
    api.get("/settings")
      .then((r) => { minutes = Number(r.data.auto_logout_minutes) || 30; reset(); })
      .catch(() => reset());
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((e) => window.addEventListener(e, reset));
    return () => {
      events.forEach((e) => window.removeEventListener(e, reset));
      clearTimeout(timer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BrandingProvider>
    <div className="flex min-h-screen brand-bg">
      {navOpen && <div className="fixed inset-0 z-40 bg-black/40 md:hidden" onClick={() => setNavOpen(false)} data-testid="mobile-nav-overlay" />}
      <Sidebar open={navOpen} />
      <main className="flex-1 min-w-0 flex flex-col">
        <div className="md:hidden sticky top-0 z-30 flex items-center gap-3 h-14 px-4 brand-sidebar text-white">
          <button onClick={() => setNavOpen(true)} aria-label="Menü öffnen" data-testid="mobile-menu-button"><Menu size={22} /></button>
          <BrandHeader compact />
        </div>
        <Outlet />
      </main>
      <Toaster position="bottom-right" richColors />
      {user?.is_chef && <MailJobsIndicator />}
    </div>
    </BrandingProvider>
  );
}
